import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import { useProducts, inr, buildLabel } from "../lib/api";

export const SearchDialog = ({ open, onOpenChange }) => {
  const [q, setQ] = useState("");
  const [debounced, setDebounced] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => setDebounced(q.trim()), 250);
    return () => clearTimeout(t);
  }, [q]);
  const { data = [], isFetching } = useProducts(debounced ? { q: debounced, limit: 6 } : { featured: true, limit: 4 });

  const close = () => { onOpenChange(false); setQ(""); };
  const submit = (e) => {
    e.preventDefault();
    if (!q.trim()) return;
    navigate(`/shop?q=${encodeURIComponent(q.trim())}`);
    close();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="top-[15%] max-w-xl translate-y-0 bg-background p-0">
        <DialogTitle className="sr-only">Search products</DialogTitle>
        <form onSubmit={submit} className="flex items-center gap-3 border-b border-border px-5">
          <Search className="h-5 w-5 text-muted-foreground" />
          <input
            autoFocus value={q} onChange={(e) => setQ(e.target.value)} data-testid="search-input"
            placeholder="Search racks, shelves, finishes..."
            className="h-14 flex-1 bg-transparent text-base outline-none placeholder:text-muted-foreground"
          />
        </form>
        <div className="max-h-[60vh] overflow-y-auto p-3">
          <p className="eyebrow px-2 pb-2">{debounced ? (isFetching ? "Searching" : `${data.length} results`) : "Popular right now"}</p>
          {data.map((p) => (
            <Link key={p.slug} to={`/product/${p.slug}`} onClick={close} data-testid={`search-result-${p.slug}`} className="flex items-center gap-4 rounded-md p-2 hover:bg-muted">
              <img src={p.images[0]} alt="" className="h-14 w-14 rounded object-cover" />
              <div className="flex-1">
                <p className="font-display text-lg leading-tight">{p.name}</p>
                <p className="text-xs text-muted-foreground">{buildLabel(p.build_minutes)}</p>
              </div>
              <span className="text-sm font-semibold">{inr(p.price)}</span>
            </Link>
          ))}
          {debounced && !isFetching && data.length === 0 && (
            <p data-testid="search-empty" className="px-2 py-6 text-sm text-muted-foreground">Nothing matches "{debounced}". Try "desk" or "shelf".</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
